import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {
    IAddPlaybookDTO, IGetPlaybookCategoriesDto,
    IGetPlaybooksListingDto,
    IPlaybookCategoryDTO, IPlaybookGuidelinesDTO,
    IPlaybooksByIdTO,
    IPlaybooksItemDTO,
    IUpdateGuidelineDTO,
    IUpdatePlaybookGuidelineDTO,
    PlaybookStatusEnum,
} from "./dto/playbooks-listening.dto";
import {
    IPlaybookDefaultFilter
} from "./legal-hub-playbooks-listening/legal-hub-basic-filters/legal-hub-basic-filters.component";

@Injectable({
    providedIn: 'root'
})
export class PlaybookListeningApiService {

    constructor(private _httpClient: HttpClient) {
    }

    searchPlaybooks(queryString: string, status?:PlaybookStatusEnum): Observable<IGetPlaybooksListingDto> {
        let httpParams = new HttpParams();

        if (queryString?.trim().length > 0) {
            httpParams = httpParams.set('name', queryString);
        }

        if (status) {
            httpParams = httpParams.set('status', status);
        }
        
        return this._httpClient.get<IGetPlaybooksListingDto>('legalhub/playbooks', {
            params: httpParams
        });
    }

    getPlaybooks(page:number = 1, search?: string, filters?:IPlaybookDefaultFilter) : Observable<IGetPlaybooksListingDto> {
        let httpParams = new HttpParams();


        if (search?.trim().length > 0) {
            httpParams = httpParams.set('name', search);
        }
        
        if(page && page > 0){
            httpParams = httpParams.set('page', page.toString());
        }

        if(filters?.status){
            httpParams = httpParams.set('status', filters?.status);
        }

        if(filters?.playbook_category_id){
            httpParams = httpParams.set('playbook_category_id', filters?.playbook_category_id);
        }

        return this._httpClient.get<IGetPlaybooksListingDto>('legalhub/playbooks',{
            params: httpParams
        });
    }
    
    getPlaybookById(playbookId:number):Observable<IPlaybooksByIdTO>{
        return this._httpClient.get<IPlaybooksByIdTO>(`legalhub/playbooks/${playbookId}`);
    }

    getPlaybookCategories(search: string =''): Observable<IGetPlaybookCategoriesDto> {
        let httpParams = new HttpParams();

        if(search?.trim().length > 0){
            httpParams = httpParams.set('name', search);
        }
        return this._httpClient.get<IGetPlaybookCategoriesDto>('legalhub/playbook-categories', {
            params: httpParams
        });
    }
    
    getGuidelinesForPlaybook(playbookId:number):Observable<any>{
        return this._httpClient.get<any>(`legalhub/playbooks/${playbookId}/playbook-guidelines`);
    }
    
    addPlaybook(playbook:IAddPlaybookDTO):Observable<IPlaybooksItemDTO>{
        return this._httpClient.post<IPlaybooksItemDTO>('legalhub/playbooks', playbook);
    }

    updatePlaybook(playbookId:number, playbook:IUpdatePlaybookGuidelineDTO):Observable<IPlaybooksItemDTO>{
        return this._httpClient.put<IPlaybooksItemDTO>(`legalhub/playbooks/${playbookId}`, playbook);
    }
 
    updateGuideline(playbookId:number, guideline:IUpdateGuidelineDTO):Observable<IPlaybookGuidelinesDTO []>{
        return this._httpClient.put<IPlaybookGuidelinesDTO []>(`legalhub/playbooks/${playbookId}/guidelines/`, {guidelines:guideline });
    }
    
    addNewCategory(categoryName:string):Observable<IPlaybookCategoryDTO>{
        return this._httpClient.post<IPlaybookCategoryDTO>('legalhub/playbook-categories', {name:categoryName});
    }


    deletePlayBook(playBookId: number) {
        return this._httpClient.delete(`legalhub/playbooks/${playBookId}`);
    }
}
